import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Grid, IconButton, Paper, TableContainer, Table, TableBody, TableCell, TableRow } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { useParams } from "react-router-dom";
import { useGetProcurementServicePackageQuery } from "store/slices/apis/procurementDashboardSlice";



const ProcurementPackages = (props) => {
    const { projectId } = useParams();
    const { open, handleClose } = props;
    const { data: packageData, isFetching: isPackageLoading, isError: isPackageError } = useGetProcurementServicePackageQuery({ projectId });

    // const { data: procurementRes, isLoading } =
    //     useGetMasterDataQuery({
    //         module: "Procurement",
    //         category: "servicesPackages",
    //         ProjectId: projectId,
    //     });

    const procurementData = packageData?.data || [];


    const half = Math.ceil(procurementData.length / 2);

    const dividedArray = [
        procurementData.slice(0, half),
        procurementData.slice(half)
    ];

    const flattenedData = dividedArray.flat().map((item, index) => ({
        value:  item,
        serialNo: index + 1
    }));

    const leftTable = flattenedData.slice(0, dividedArray[0].length);
    const rightTable = flattenedData.slice(dividedArray[0].length);

    const ProcurementTable = ({ data }) => (
        <TableContainer component={Paper} variant="outlined">
            <Table size="small">
                <TableBody>
                    {data.map(item => (
                        <TableRow key={item.serialNo}
                            sx={{
                                "&:nth-of-type(odd)": {
                                    backgroundColor: "#F9FAFB",
                                },
                                "&:hover": {
                                    backgroundColor: "#EEF2FF",
                                },
                            }}>
                            <TableCell sx={{ border: "1px solid #E4E4E4" }}>
                                {item.serialNo}
                            </TableCell>
                            <TableCell sx={{ border: "1px solid #E4E4E4" }}>
                                {item.value}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", height: "60vh" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,

            }}>

                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    Service Packages
                </Typography>

                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 12,
                        top: 12,
                        color: "#140F36",
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ overflowY: "auto" }}>
                <Grid container spacing={2}>
                    {!isPackageLoading && flattenedData.length > 0 && (
                        <>
                            <Grid size={{ md: 6 }}>
                                <ProcurementTable data={leftTable} />
                            </Grid>

                            <Grid size={{ md: 6 }}>
                                <ProcurementTable data={rightTable} />
                            </Grid>
                        </>
                    )}
                    {/* <Grid size={12}>

                        <Grid size={12}>


                            <TableContainer component={Paper} variant="outlined">
                                <Table size="small">
                                    <TableBody>
                                        {!isLoading && rows.length > 0 &&
                                            rows.map((row, rowIndex) => (
                                                <TableRow key={rowIndex}>
                                                    {[0, 1].map((colIndex) => {
                                                        const item = row[colIndex];
                                                        const serialNo = rowIndex * 2 + colIndex + 1;

                                                        return (
                                                            <TableCell
                                                                key={colIndex}
                                                                sx={{
                                                                    border: "1px solid #E4E4E4",
                                                                    p: "8px"
                                                                }}
                                                            >
                                                                {item ? (
                                                                    <Typography
                                                                        sx={{
                                                                            fontFamily: "Outfit",
                                                                            fontSize: "13px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: "6px"
                                                                        }}
                                                                    >
                                                                        <span style={{ fontSize: "12px", color: "#6B7280" }}>
                                                                            {serialNo}.
                                                                        </span>
                                                                        <span>{item.value}</span>
                                                                    </Typography>
                                                                ) : null}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            ))}

                                        {!isLoading && rows.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={2} align="center">
                                                    <Typography variant="caption" color="text.secondary">
                                                        No data available
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </Grid>

                    </Grid> */}
                </Grid>
            </DialogContent>
        </Dialog >
    );
};

export default ProcurementPackages;